import { Box } from '@mui/material';
import type { SxProps } from '@mui/material';
import { ArrowDownRedIcon, ArrowUpGreenIcon } from '../icons';

export type TrendArrowProps = {
    trend: number | null;
    arrowSize?: number;
    textSize?: number;
    sx?: SxProps;
};
const signedTrendValue = (trend: number) => {
    if (trend > 0) {
        return '+' + trend.toString();
    }
    if (trend < 0) {
        return trend.toString();
    }
    return '±0';
};

export function TrendArrow({
    trend,
    arrowSize = 18,
    textSize = 16,
    sx,
}: TrendArrowProps) {
    if (trend === null) {
        return null;
    }
    return (
        <Box
            data-testid="trend"
            fontSize={textSize}
            fontWeight="bold"
            display="flex"
            alignItems="center"
            justifyContent="center"
            gap={0.5}
            sx={sx}
        >
            <span>{signedTrendValue(trend)}</span>
            {trend >= 3 ? (
                <ArrowUpGreenIcon size={arrowSize} />
            ) : trend <= -3 ? (
                <ArrowDownRedIcon size={arrowSize} />
            ) : null}
        </Box>
    );
}
